import React from "react";

import styles from "./TriangleContent.module.scss";

export const TriangleContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, className, ...rest }, ref) => (
  <div
    ref={ref}
    className={`${styles.triangleContainer} ${className ?? ""}`}
    {...rest}>
    {children}
  </div>
));
TriangleContainer.displayName = "TriangleContainer";

export const DiagonalLine: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.diagonalLine} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const LeftItemContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.leftItemContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const RightItemContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.rightItemContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);
